import { Controller } from 'react-hook-form';
import { Select, DateInput, Textarea } from '@ui/src';
import { NotificationItemIssueStatus } from '../../hoc/center/types';
import { EditSidepanelTypes } from './types';

import cn from './styles.module.css';

const EditNotificationsSidepanel = ({
  control,
  selectedNotifications,
  employees,
  batchUpdateInProgress,
  errors,
  currentUser,
  editIssueFields,
  setValue,
}: EditSidepanelTypes) => (
  <div className={cn.editNotificationsSidepanel}>
    <div
      className={cn.selectedNotificationsCount}
    >{`Selected notifications: ${selectedNotifications?.length}`}</div>
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="status"
        defaultValue=""
        render={({ field: { value, name, onChange } }) => (
          <Select
            name={name}
            value={value}
            list={[
              {
                name: `${NotificationItemIssueStatus.TODO.charAt(
                  0,
                )}${NotificationItemIssueStatus.TODO.slice(1).toLowerCase()}`,
                value: NotificationItemIssueStatus.TODO,
              },
              {
                name: NotificationItemIssueStatus.IN_PROGRESS.split('_')
                  .map(
                    (item) => `${item.charAt(0)}${item.slice(1).toLowerCase()}`,
                  )
                  .join(' '),
                value: NotificationItemIssueStatus.IN_PROGRESS,
              },
              {
                name: `${NotificationItemIssueStatus.DONE.charAt(
                  0,
                )}${NotificationItemIssueStatus.DONE.slice(1).toLowerCase()}`,
                value: NotificationItemIssueStatus.DONE,
              },
              {
                name: `${NotificationItemIssueStatus.CANCELED.charAt(
                  0,
                )}${NotificationItemIssueStatus.CANCELED.slice(
                  1,
                ).toLowerCase()}`,
                value: NotificationItemIssueStatus.CANCELED,
              },
            ]}
            error={errors?.status?.message}
            placeholder="Select status"
            onChange={onChange}
            title="Status"
            disabled={batchUpdateInProgress}
            fullWidth
          />
        )}
      />
    </div>
    <div className={`${cn.formGroup} ${cn.formGroupFlex}`}>
      <div className={cn.formGroupItem}>
        <Controller
          control={control}
          name="responsibleId"
          defaultValue=""
          render={({ field: { value, name, onChange } }) => (
            <Select
              name={name}
              value={value}
              list={employees}
              placeholder="Assign Responsible"
              onChange={onChange}
              title="Responsible"
              disabled={batchUpdateInProgress}
              error={errors?.responsibleId?.message}
              withButtonInTitle={
                currentUser?.id !== editIssueFields?.responsibleId
              }
              titleButtonText="Assign to me"
              onTitleButtonClick={() =>
                setValue('responsibleId', currentUser?.id)
              }
            />
          )}
        />
      </div>
      <div className={cn.formGroupItem}>
        <Controller
          control={control}
          name="executorId"
          defaultValue=""
          render={({ field: { value, name, onChange } }) => (
            <Select
              name={name}
              value={value}
              list={employees}
              placeholder="Assign Executor"
              onChange={onChange}
              title="Executor"
              disabled={batchUpdateInProgress}
              error={errors?.executorId?.message}
              withButtonInTitle={
                currentUser?.id !== editIssueFields?.executorId
              }
              titleButtonText="Assign to me"
              onTitleButtonClick={() => setValue('executorId', currentUser?.id)}
            />
          )}
        />
      </div>
    </div>
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="deadline"
        defaultValue=""
        render={({ field: { value, onChange } }) => (
          <DateInput
            value={value}
            onChange={(date) => onChange(date.toISOString())}
            title="Deadline"
            placeholder="Select date"
            className={cn.deadlineEditFilter}
            disabled={batchUpdateInProgress}
            error={errors?.deadline?.message}
            withoutCustomSelector
            withValueReset
          />
        )}
      />
    </div>
    <div className={cn.separator} />
    <div className={cn.formGroup}>
      <Controller
        control={control}
        name="comment"
        defaultValue=""
        render={({ field: { value, onChange, name } }) => (
          <Textarea
            name={name}
            value={value}
            placeholder="Enter comment..."
            onChange={onChange}
          />
        )}
      />
    </div>
  </div>
);

export default EditNotificationsSidepanel;
